import React from 'react';
import {
  TrialsLink,
  TrialsPageFooterWrapper,
} from '../../../screens/Trials/styles';

export const TrialsPageFooter = () => (
  <TrialsPageFooterWrapper>
    This site is protected by reCAPTCHA and the
    <br />
    Google{' '}
    <TrialsLink href="https://policies.google.com/privacy" target="_blank">
      Privacy Policy
    </TrialsLink>{' '}
    and{' '}
    <TrialsLink href="https://policies.google.com/terms" target="_blank">
      Terms of Service
    </TrialsLink>{' '}
    apply.
  </TrialsPageFooterWrapper>
);
